import { numberFormat } from '@/helpers/numbers'
import { Grid, Stack, Typography } from '@mui/material'

import React from 'react'
import { useTranslation } from 'react-i18next'

type Props = {
  balance: number
  subsidy: number
  unlimitedSubsidy: boolean
  variant?: 'card' | 'compact'
}

const CreditsAndSubsidyCard: React.FC<Props> = ({
  balance,
  subsidy,
  unlimitedSubsidy,
  variant = 'card',
}) => {
  const { t } = useTranslation()

  const columns = (
    <Grid
      container
      sx={{
        overflowWrap: 'anywhere',
      }}>
      <Grid size={6} sx={{ padding: '8px' }}>
        <Stack>
          <Typography variant="caption" fontSize={'10px'}>
            {t('cc:navBar.purchasedCredits')}
          </Typography>
          <Typography variant="body2" fontWeight={'600'}>
            {numberFormat(balance)} {t('cc:navBar.credits')}
          </Typography>
        </Stack>
      </Grid>
      <Grid size={6} sx={{ borderLeft: '1px solid', borderColor: 'divider', padding: '8px' }}>
        <Stack>
          <Typography variant="caption" fontSize={'10px'}>
            {t('cc:navBar.subsidy')}
          </Typography>
          <Typography variant="body2" fontWeight={'600'}>
            {unlimitedSubsidy
              ? t('cc:navBar.unlimited')
              : `${numberFormat(subsidy)} ${t('cc:navBar.freeCredits')}`}
          </Typography>
        </Stack>
      </Grid>
    </Grid>
  )

  if (variant === 'compact') {
    return <Grid sx={{ borderTop: '1px solid', borderColor: 'divider' }}>{columns}</Grid>
  }

  return (
    <Grid size={{ xs: 12, sm: 12, md: 4, lg: 3 }}>
      <Stack
        sx={{
          border: '1px solid',
          borderRadius: 2,
          borderColor: 'divider',
        }}>
        <Grid
          sx={{
            borderBottom: '1px solid',
            borderColor: 'divider',
            padding: '8px 16px',
          }}>
          <Typography variant="subtitle2">{t('cc:navBar.creditsTitle')}</Typography>
        </Grid>
        {columns}
      </Stack>
    </Grid>
  )
}

export default CreditsAndSubsidyCard
